import { StoreCategoriesSidebarSkeleton } from "@/components/e-commerce/store/categories-sidebar/skeleton"
import { Skeleton } from "@/components/ui/skeleton"

const TAB_COUNT = 2
const PRODUCT_CARD_COUNT = 6
const TAB_PLACEHOLDERS = Array.from({ length: TAB_COUNT }, (_, index) => ({
  id: `tab-skeleton-${index + 1}`,
}))
const PRODUCT_CARD_PLACEHOLDERS = Array.from(
  { length: PRODUCT_CARD_COUNT },
  (_, index) => ({
    id: `product-card-skeleton-${index + 1}`,
  })
)

const StoreHeaderSkeleton = (): React.ReactNode => {
  return (
    <div className='overflow-hidden rounded-xl border border-gray-200 bg-white'>
      <Skeleton className='h-36 w-full' />
      <div className='space-y-4 p-4'>
        <div className='flex items-center gap-4'>
          <Skeleton className='h-20 w-20 rounded-full' />
          <div className='space-y-2'>
            <Skeleton className='h-7 w-60' />
            <Skeleton className='h-4 w-40' />
          </div>
        </div>
        <div className='grid grid-cols-1 gap-2 sm:grid-cols-2'>
          <Skeleton className='h-4 w-full' />
          <Skeleton className='h-4 w-full' />
          <Skeleton className='h-4 w-4/5' />
          <Skeleton className='h-4 w-3/5' />
        </div>
      </div>
    </div>
  )
}

const StoreTabsSkeleton = (): React.ReactNode => {
  return (
    <div className='space-y-4 rounded-xl border border-gray-200 bg-white p-4'>
      <div className='flex items-center gap-3 border-b pb-4'>
        {TAB_PLACEHOLDERS.map((placeholder) => (
          <Skeleton className='h-9 w-30 rounded-md' key={placeholder.id} />
        ))}
      </div>

      <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3'>
        {PRODUCT_CARD_PLACEHOLDERS.map((placeholder) => (
          <div
            className='space-y-3 rounded-lg border border-gray-200 p-3'
            key={placeholder.id}
          >
            <Skeleton className='aspect-square w-full rounded-md' />
            <Skeleton className='h-4 w-4/5' />
            <Skeleton className='h-4 w-1/2' />
            <Skeleton className='h-9 w-full rounded-md' />
          </div>
        ))}
      </div>
    </div>
  )
}

export default function Loading() {
  return (
    <main aria-busy='true' aria-live='polite' className='mx-auto w-full p-6'>
      <div className='mx-auto grid w-full max-w-400 grid-cols-1 gap-6 lg:grid-cols-[18rem_minmax(0,1fr)]'>
        <StoreCategoriesSidebarSkeleton />

        <section className='space-y-4'>
          <StoreHeaderSkeleton />
          <Skeleton className='h-11 w-full rounded-xl' />
          <StoreTabsSkeleton />
        </section>
      </div>
    </main>
  )
}
